const ClientPermissions = {
  mainPage: false,
  projectsPage: false,
  batchesPage: false,
  usersPage: false,
  viewImages: true,
  annotate: true,
  addProject: false,
  addBatch: false,
  addUser: false,
  addPermissions: false,
  addImages: false,
  viewBatches: false,
  deleteProjects: false,
  deleteBatches: false,
  export: false,
  import: false,
  editUsers: false,
  showWhizz: true,
  downloadImage: false,
  editFields: true,
};
export default ClientPermissions;
